import { type AccountFilterValue } from './types';

export const FILTERS: { value: AccountFilterValue; label: string; ariaLabel: string }[] = [
  { value: 'all', label: 'All', ariaLabel: 'All accounts' },
  { value: 'owner', label: 'Owned', ariaLabel: 'Owned accounts' },
  { value: 'member', label: 'Invited', ariaLabel: 'Invited accounts' },
];

export const QUOTA_INCREASE_DESCRIPTION =
  'I would like to request an increase to my account creation limit. ' +
  'I have reached the current quota and need to create additional accounts for my team/organization.';
